export function LabMinusIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <path d="M2.91675 7H11.0834" stroke="currentColor" strokeWidth="1.16" strokeLinecap="square" strokeLinejoin="round" />
    </svg>
  );
}
